import { list, object, primitive, serializable } from 'serializr';

export class ProfileAddon {
  @serializable
  name?: string;
}

export class ProfileSubscription {
  @serializable
  type?: string;

  @serializable
  expiresAt?: string;

  @serializable(list(object(ProfileAddon)))
  addons?: ProfileAddon[];
}

export class ProfileRenewalStatus {
  @serializable
  lastRenewRequestAt?: string | null;

  @serializable
  nextAvailableAt?: string | null;

  @serializable
  canRenew?: boolean;
}

export class ProfileSubscriptionStatus {
  @serializable
  lastSubscribeRequestAt?: string | null;

  @serializable
  nextAvailableAt?: string | null;

  @serializable
  canSubscribe?: boolean;
}

export class Profile {
  @serializable
  id!: number;

  @serializable
  name?: string;

  @serializable
  title?: string;

  @serializable
  email?: string;

  @serializable
  phone?: string;

  @serializable
  role?: string;

  @serializable(list(primitive()))
  groups?: string[];

  @serializable
  clientOrgName?: string;

  @serializable
  subscriptionExpiresAt?: string;
}

export class ProfileResponse {
  @serializable(object(Profile))
  profile?: Profile;

  @serializable(object(ProfileSubscription))
  subscription?: ProfileSubscription;

  @serializable(object(ProfileRenewalStatus))
  renewalStatus?: ProfileRenewalStatus;

  @serializable(object(ProfileSubscriptionStatus))
  subscriptionStatus?: ProfileSubscriptionStatus;
}

export interface EditProfilePayload {
  name?: string;
  title?: string;
  email?: string;
  phone?: string;
}

export interface EditProfileResponse {
  message: string;
  emailChanged: boolean;
}

export interface SetProfilePasswordPayload {
  password: string;
  confirmPassword: string;
}

export interface SetProfilePasswordResponse {
  message: string;
  requiresLogout: boolean;
}

export interface SubscriptionActionResponse {
  message: string;
  success: boolean;
  nextAvailableAt: string;
}
